// src/pages/Users/Galleries/components/GalleriesHero.jsx

import React from "react";
import { FaEye, FaImages, FaLock, FaPhotoVideo } from "react-icons/fa";

export default function GalleriesHero({
  totalAlbums,
  visibleAlbums,
  totalPhotos,
  inactiveAlbums,
  isManager,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full bg-orange-500/25 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-48 w-48 rounded-full bg-sky-500/25 blur-3xl" />

      <div className="relative grid gap-5 lg:grid-cols-[1.1fr_0.9fr] lg:items-end">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-orange-200">
            Souvenirs · événements · vie du club
          </p>

          <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
            Les albums photos du club
          </h2>

          <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-200 sm:text-base">
            Parcours les photos des compétitions, stages, cérémonies, animations
            et moments forts du club. Les albums sont organisés pour une lecture
            simple sur smartphone.
          </p>
        </div>

        <div className="grid grid-cols-4 gap-2">
          <HeroStat icon={FaImages} label="Albums" value={totalAlbums} />
          <HeroStat icon={FaEye} label="Affichés" value={visibleAlbums} />
          <HeroStat icon={FaPhotoVideo} label="Photos" value={totalPhotos} />
          <HeroStat
            icon={FaLock}
            label={isManager ? "Masqués" : "Club"}
            value={isManager ? inactiveAlbums : "OK"}
          />
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-2.5 text-center backdrop-blur sm:p-3">
      <div className="mx-auto flex h-8 w-8 items-center justify-center rounded-xl bg-white/15 sm:h-9 sm:w-9">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-base font-bold leading-none sm:text-lg">
        {value}
      </p>

      <p className="mt-1 text-[10px] font-medium text-slate-300 sm:text-[11px]">
        {label}
      </p>
    </div>
  );
}